<template>
  <div class="table-view">
    <VSidebarLayoutHeading v-bind="sidebar">
      <slot name="search"></slot>
    </VSidebarLayoutHeading>

    <div
      class="table-view__table-wrapper"
      :class="{ ['with-pagination']: withPagination }"
    >
      <slot name="table"></slot>
    </div>

    <slot name="pagination"></slot>
    <slot name="extra"></slot>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import Layout from "@/layouts/Layout";
import VSidebarLayoutHeading from "@/components/VSidebarLayoutHeading";

export default Vue.component("VTableView", {
  props: {
    sidebar: VueTypes.shape({
      title: VueTypes.string,
      buttons: VueTypes.array,
      extraClass: VueTypes.string
    }),
    withPagination: VueTypes.bool.def(true)
  },

  components: {
    Layout,
    VSidebarLayoutHeading
  }
});
</script>

<style lang="scss">
$ns: "table-view";

.#{$ns} {
  // TABLE OVERRIDES
  &__table-wrapper {
    position: relative;
    height: calc(100vh - 140px);
    overflow: hidden;
    overflow-y: auto;
    padding-right: 10px;

    &.with-pagination {
      height: calc(100vh - 162px);
      @media screen and (max-width: $tablet-screen) {
        height: calc(100vh - 222px);
      }
    }

    table thead th {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 5;
      background: #fff;
    }

    table {
      th,
      td {
        &.context-menu {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
      }
    }

    @media screen and (max-width: $mid-screen) {
      .contact-table__wrapper {
        height: calc(100vh - 330px);
      }
    }
  }

  // LAYOUT OVERRIDES
  .sidebar-layout__wrapper.table-view-layout {
    .sidebar-layout__content-wrapper {
      padding-bottom: 0;
    }

    @media screen and (min-width: $tablet-screen) {
      .sidebar-layout__content {
        padding: $general-padding 43px;
      }
    }
  }

  .sidebar-layout__wrapper .contacts-layout-heading {
    .sidebar-layout-heading__title {
      align-items: center;

      @media screen and (max-width: 991px) {
        flex-direction: column;
        margin-bottom: 0;

        .contacts-filter__wrapper {
          margin-left: 0;
          margin-top: 10px;

          .contacts-filter.primary input {
            width: 100%;
          }
        }
      }
    }

    @media screen and (max-width: 600px) {
      & {
        flex-direction: column;

        .sidebar-layout-heading__title {
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
